import React, { useEffect, useState } from "react";
import signinImg from "../../assets/images/signin-logo.png";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { useFormik } from "formik";
import { object, string } from "yup";
import axios from "axios";
import PinField from "react-pin-field";

let loginSchema = object({
  otp: string().required("OTP is required").length(4, "OTP must be 4 digits"),
});

export const OtpScreen = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const navigate = useNavigate();
  const MobileNumber = localStorage.getItem("mobile_no");
  const otpToken = localStorage.getItem("otp_token");

  const formik = useFormik({
    initialValues: {
      mobile_number: "",
      otp: "",
      user_type: "admin",
    },
    validationSchema: loginSchema,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      setServerError("");

      const payload = {
        mobile_number: MobileNumber,
        otp: values.otp,
        user_type: "admin",
      };

      console.log("👉 Payload before sending to API:", payload);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/verify-otp/`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${otpToken}`,
            },
          }
        );
        console.log("✅ Response from API:", response);

        if (response.data.status === "success") {
          localStorage.setItem("mobile_no", values.mobile_no);
          navigate("/reset-password");
        } else {
          setServerError(response.data.message || "failed");
        }
      } catch (error) {
        setServerError(
          error.response?.data?.message ||
            "Something went wrong. Please try again."
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="signin-container">
      <div className="signin-left">
        <div>
          <div className="signin-logo">
            <img src={signinImg} />
          </div>
          <div className="signin-lefttext">
            Welcome to the Go Mak Admin Dashboard — your all-in-one platform for
            managing and optimizing medicine delivery operations. From tracking
            orders and monitoring delivery partners to ensuring security,
            reliability, and on-time service, this dashboard empowers you to
            streamline processes and provide healthcare providers with the
            medicines they need, when they need them.amco laboris nisi ut
            aliquip ex ea commodo consequat.{" "}
          </div>
        </div>
      </div>
      <div className="signin-right">
        <div>
          <form className="signin-formContainer" onSubmit={formik.handleSubmit}>
            <div className="signin-title">Enter OTP</div>
            {/* <div className="signin-subtitle">Welcome to Go Mak Admin</div> */}
            <div className="signin-field">
              <label>
                <span className="text-danger">*</span>OTP
              </label>
              <div className="otp-input">
                <PinField
                  length={4}
                  onChange={(value) => {
                    if (formik.values.otp !== value) {
                      formik.setFieldValue("otp", value);
                    }
                  }}
                  validate="0123456789"
                  inputMode="numeric"
                  className="pin-box"
                  autoFocus
                />
                {formik.touched.otp && formik.errors.otp && (
                  <div className="error-message-signIn">
                    {formik.errors.otp}
                  </div>
                )}
              </div>
            </div>
            <div className="btnLogin">
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Submiting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
